import React from 'react';
import { Button } from '@mui/material';
import PolarisIcon from '../PolarisIcon';

interface ResetButtonProps {
  label?: string;
  color?: 'primary' | 'inherit' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  onClick: () => void;
}

const ResetButton = ({ color = 'primary', label = 'Reset to Defaults', onClick }: ResetButtonProps) => {
  return (
    <Button color={color} variant="outlined" size="small" onClick={onClick} startIcon={<PolarisIcon icon="reset" />}>
      {label}
    </Button>
  );
};

export default ResetButton;
